import styled, { css } from 'styled-components';

const SpinnerContainer = styled.div<{ fullscreen?: boolean }>`
  display: inline-block;
  ${({ fullscreen }) =>
    fullscreen && {
      display: 'flex',
      position: 'fixed',
      justifyContent: 'center',
      alignItems: 'center',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      zIndex: 1000,
      background: 'rgba(0, 0, 0, .75)',
      width: '100% !important',
      height: '100% !important',
    }}
`;

const Spin = css`
  animation: spin 2s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const LoadingSpinner = styled.div<{ animate?: boolean }>`
  display: inline-block;
  border: 4px solid ${({ theme }) => theme.palette.accent.primary.strong};
  border-left-color: ${({ theme }) => theme.palette.accent.primary.subtle};
  border-bottom-color: ${({ theme }) => theme.palette.accent.primary.subtle};
  border-radius: 50%;
  ${({ animate }) => animate && Spin}
`;

export interface LoadingIndicatorProps {
  radius?: number;
  animate?: boolean;
  fullscreen?: boolean;
  className?: string;
}

export const LoadingIndicator = (props: LoadingIndicatorProps) => {
  const { radius, animate = false, fullscreen, className } = props;
  const width = radius ?? 24;
  const height = radius ?? 24;

  return (
    <SpinnerContainer className={className} style={{ width, height }} fullscreen={fullscreen}>
      <LoadingSpinner style={{ width, height }} animate={animate} data-testid="loading-indicator" />
    </SpinnerContainer>
  );
};
